import axios from 'axios'

export default {
  namespaced: true,
  state: {
    employeeSalaryPeriodGrid: [],
    employeeSalaryPeriod: {
      period: {}
    },
    pageData: null,
  },
  mutations: {
    setEmployeeSalaryPeriodGrid(state, payload) {
      state.employeeSalaryPeriodGrid = payload
    },
    setEmployeeSalaryPeriod(state, payload) {
      state.employeeSalaryPeriod = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    employeeSalaryPeriodGrid: (state) => {
      return state.employeeSalaryPeriodGrid
    },
    employeeSalaryPeriod: (state) => {
      return state.employeeSalaryPeriod
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onEmployeeSalaryPeriodGrid({commit, rootState}, {limit, page, search, type}) {
      commit('setLoadingAnimationFullPage', true, {root: true})
      let url = rootState.apiDomain + '/api/admin/employee/salary/period/grid?limit=' + limit + '&page=' + page
      if (search) url = url + '&search=' + search
      if (type) url = url + '&type=' + type
      url = url + '&order[]=id:desc'
      return new Promise((resolve, reject) => {
        axios({url, limit: limit, page: page, method: 'GET'})
          .then((resp) => {
            commit('setEmployeeSalaryPeriodGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimationFullPage', false, {root: true})
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, {root: true})
            reject(err)
          })
      })
    },
    onEmployeeSalaryPeriod({commit, rootState}, {id, user, project}) {
      commit('setLoadingAnimationFullPage', true, {root: true})
      let url = rootState.apiDomain + '/api/admin/employee/salary/period/' + id + '?raw=1'
      if (user) for (let i in user) url = url + '&user_ids[]=' + user[i]
      if (project) for (let i in project) url = url + '&project_ids[]=' + project[i]
      return new Promise((resolve, reject) => {
        axios({url, method: 'GET'})
          .then((resp) => {
            commit('setEmployeeSalaryPeriod', resp.data)
            commit('setLoadingAnimationFullPage', false, {root: true})
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, {root: true})
            reject(err)
          })
      })
    }
  }
}
